import { chakra } from '@chakra-ui/react';

const SmartphoneBr = chakra('br', {
  baseStyle: {
    display: { base: 'inherit', sm: 'none' },
  },
});

const HeadingText = chakra('h2', {
  baseStyle: {
    fontSize: { base: '2xl', sm: '4xl' },
    fontWeight: '700',
    lineHeight: '1.2',
    textAlign: 'center',
    letterSpacing: 'wider',
  },
});

const SubtitleText = chakra('div', {
  baseStyle: {
    fontSize: 'sm',
    color: '#a29a1f',
    letterSpacing: '0.4rem',
    py: '20px',
  },
});

const HighlightedText = chakra('span', {
  baseStyle: {
    color: '#cf1359',
    fontWeight: '700',
  },
});

const ParagraphText = chakra('p', {
  baseStyle: {
    fontWeight: '700',
    fontSize: { base: 'md', xs: 'xl' },
  },
});

const Section = chakra('section', {
  baseStyle: {
    paddingTop: '60px',
    paddingBottom: '60px',
  },
});

export {
  SmartphoneBr,
  HeadingText,
  SubtitleText,
  HighlightedText,
  ParagraphText,
  Section,
};
